// extracted by mini-css-extract-plugin
export default {"container":"container__g3Awz","skeleton":"skeleton__kZr0V","content":"content__09G4g"};